import { FontStyles } from "../utils/font-styles.ts";
import { TextLink } from "../components/text-link.tsx";

export const HRDisclaimer = () => {
  return (
    <p className={`${FontStyles["body-l"]} leading-snug md:leading-snug`}>
      <span>* ESPC member firms achieved an average of </span>
      <TextLink href="/more">2% more above Home Report valuation</TextLink>
      <span> than non solicitor estate agents</span>
    </p>
  );
};
